var exports = {
  "kL": "CompactVoiceCallView.module__container___MlNYem",
  "gw": "CompactVoiceCallView.module__containerNoHeader___MlNYem",
  "lf": "CompactVoiceCallView.module__containerReserveHeaderChrome___MlNYem",
  "L7": "CompactVoiceCallView.module__containerNoControlBar___MlNYem",
  "ap": "CompactVoiceCallView.module__containerFillHeight___MlNYem",
  "tZ": "CompactVoiceCallView.module__contentArea___MlNYem",
  "$7": "CompactVoiceCallView.module__contentAreaAudioOnly___MlNYem",
  "OZ": "CompactVoiceCallView.module__audioAvatarLayout___MlNYem",
  "a3": "CompactVoiceCallView.module__audioAvatarLayoutInner___MlNYem",
  "d6": "CompactVoiceCallView.module__audioAvatarLayoutFullBleed___MlNYem",
  "nd": "CompactVoiceCallView.module__audioAvatarLayoutInnerFullBleed___MlNYem",
  "Gq": "CompactVoiceCallView.module__audioAvatarList___MlNYem",
  "D9": "CompactVoiceCallView.module__layoutHost___MlNYem",
  "pl": "CompactVoiceCallView.module__layoutHostFullHeight___MlNYem",
  "DO": "CompactVoiceCallView.module__layoutHostFullHeightGrid___MlNYem",
  "vR": "CompactVoiceCallView.module__layoutHostFullHeightFocus___MlNYem",
  "_t": "CompactVoiceCallView.module__controlBarSection___MlNYem",
  "Vw": "CompactVoiceCallView.module__controlBarInner___MlNYem",
  "AD": "CompactVoiceCallView.module__fullscreenButtonWrap___MlNYem",
  "I": "CompactVoiceCallView.module__heightToggleButtonWrap___MlNYem",
  "Ip": "CompactVoiceCallView.module__heightToggleButtonShell___MlNYem",
  "x8": "CompactVoiceCallView.module__heightTogglePill___MlNYem",
  "_A": "CompactVoiceCallView.module__heightTogglePillIcon___MlNYem",
  "oP": "CompactVoiceCallView.module__heightToggleUnreadBadge___MlNYem",
  "Di": "CompactVoiceCallView.module__resizeHandle___MlNYem",
  "YC": "CompactVoiceCallView.module__resizePill___MlNYem",
  "$I": "CompactVoiceCallView.module__containerResizing___MlNYem",
};

module.exports = exports;
